// extracted by mini-css-extract-plugin
export default {"tabcard":"TabCard_tabcard__va3NM"};